import styled from 'styled-components';

import { HeaderProps } from './Header';

export const HeaderStyled = styled.h2<Pick<HeaderProps, 'size' | 'spacing'>>`
  display: flex;
  word-break: break-word;

  ${({ size }) => {
    switch (size) {
      case 'xsmall': {
        return `
          font-size: 12px;
          line-height: 14px;
        `;
      }
      case 'small': {
        return `
          font-size: 14px;
          line-height: 16px;
        `;
      }
      case 'medium': {
        return `
          font-size: 16px;
          line-height: 24px;
        `;
      }
      default: {
        return `
          font-size: 20px;
          line-height: 24px;
        `;
      }
    }
  }}

  ${({ spacing }) => {
    switch (spacing) {
      case 'small': {
        return `
          margin: 0;
          padding-top: 8px;
          padding-bottom: 8px;
        `;
      }
      case 'medium': {
        return `
          padding-top: 16px;
          padding-bottom: 16px;
        `;
      }
    }
  }}
`;

export const HeaderIconStyled = styled.span`
  margin-right: 8px;
`;

export const HeaderTextStyled = styled.span``;
